export function resolveImagePath(imagePath: string): string {
  if (!imagePath) return '';

  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  try {
    const cleanPath = imagePath.replace(/^\/+/, '');
    return new URL(`./templates/assets/${cleanPath}`, import.meta.url).href;
  } catch (error) {
    console.error(`Failed to resolve image path: ${imagePath}`, error);
    return '';
  }
}
